import { render, staticRenderFns } from "./UrlAttachmentPreview.vue?vue&type=template&id=208abe40"
import script from "./UrlAttachmentPreview.vue?vue&type=script&lang=js"
export * from "./UrlAttachmentPreview.vue?vue&type=script&lang=js"
import style0 from "./UrlAttachmentPreview.vue?vue&type=style&index=0&id=208abe40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports